/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const cloud_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="m18.938 12.012-.742-.11a.75.75 0 0 0 .8.858l-.058-.748ZM8.126 11.32a.75.75 0 0 0 .748-1.3l-.748 1.3ZM6 19.25A4.25 4.25 0 0 1 1.75 15H.25A5.75 5.75 0 0 0 6 20.75v-1.5ZM22.5 16a3.25 3.25 0 0 1-3.25 3.25v1.5A4.75 4.75 0 0 0 24 16h-1.5ZM6 20.75h13.25v-1.5H6v1.5ZM1.75 15a4.252 4.252 0 0 1 3.456-4.176L4.927 9.35A5.752 5.752 0 0 0 .25 15h1.5Zm4.062-4.828C6.195 6.822 9.184 4.75 12 4.75v-1.5c-3.456 0-7.195 2.528-7.679 6.752l1.49.17ZM12 4.75c4.143 0 6.7 3.737 6.196 7.153l1.484.218C20.3 7.913 17.17 3.25 12 3.25v1.5Zm6.995 8.01C20.85 12.617 22.5 14.137 22.5 16H24c0-2.741-2.399-4.946-5.12-4.736l.115 1.496Zm-13.79-1.936a4.301 4.301 0 0 1 2.921.496l.748-1.3a5.801 5.801 0 0 0-3.947-.67l.279 1.474Z"
    />
  </svg>
)
export default cloud_medium
